import { localizeFuelingProcessStateName } from "components/FuelingProcessStatus/utils";
import { getProductName } from "components/FuelProductName/productIdToProductNameDictionary";
import { sortBy, sortedUniqBy, startCase } from "lodash";
import { useMemo } from "react";

import FuelingProcessTableItem from "./FuelingProcessTableItem";

export default function useFilterItems(processes: FuelingProcessTableItem[]) {
  return useMemo(() => {
    const getColumnFilterItems = <T>(
      getValue: (item: FuelingProcessTableItem) => T | undefined,
      getText?: (item: FuelingProcessTableItem) => string
    ) => {
      const notEmptyValueItems = processes.filter((item) => !!getValue(item));
      const sortedItems = sortBy(notEmptyValueItems, getValue);
      const uniqueItems = sortedUniqBy(sortedItems, getValue);

      return uniqueItems.map((item) => {
        const value = getValue(item) as T;
        return {
          text: getText ? getText(item) : value,
          value,
        };
      });
    };

    return {
      states: getColumnFilterItems(
        (item) => item.state,
        (item) => localizeFuelingProcessStateName(item.state)
      ),
      productIds: getColumnFilterItems(
        (item) => item.productId,
        (item) => getProductName(item.vendor, item.productId)
      ),
      suppliers: getColumnFilterItems((item) => item.supplierId),
      rejectionReasons: getColumnFilterItems(
        (item) => item.rejectionReason,
        (item) => startCase(item.rejectionReason)
      ),
      clients: getColumnFilterItems((item) => item.clientId),
      partners: getColumnFilterItems((item) => item.partnerId),
    };
  }, [processes]);
}
